<template>
<!--  <div class="sbl-circ-path"></div>-->
  <div class="r-d-loader__container">
    <img src="/images/shared/Robins-And-Day-Loader-Purple.svg" alt="Loading" class="r-d-loader__svg" >
  </div>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.sbl-circ-path {
  height: 48px;
  width: 48px;
  color: rgba(90, 90, 90, 0.2);
  position: relative;
  display: inline-block;
  border: 5px solid;
  border-radius: 50%;
  border-right-color: #5a5a5a;
  animation: rotate 1s linear infinite;
  left: 47%;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.r-d-loader {
  &__container {
    display: flex;
    justify-content: center;
  }

  &__svg {
    width: 100%;
    max-width: 150px;
  }
}
</style>